/**
 * @generated SignedSource<<87c12fb8564e0db75c3889f38ad5e123>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ClassByIdQuery$variables = {
  classId: string;
  skip?: boolean | null | undefined;
  validCurrentRoadmapsOnly?: boolean | null | undefined;
};
export type ClassByIdQuery$data = {
  readonly class?: {
    readonly createdBy: {
      readonly firstName: string | null | undefined;
      readonly id: string;
      readonly lastName: string | null | undefined;
    } | null | undefined;
    readonly externalSync: {
      readonly source: string | null | undefined;
    } | null | undefined;
    readonly gradeLevels: ReadonlyArray<{
      readonly id: string;
      readonly name: string | null | undefined;
    } | null | undefined> | null | undefined;
    readonly id: string;
    readonly isActive: boolean;
    readonly name: string | null | undefined;
    readonly section: string | null | undefined;
    readonly site: {
      readonly id: string;
      readonly name: string | null | undefined;
    } | null | undefined;
    readonly users: ReadonlyArray<{
      readonly classes: ReadonlyArray<{
        readonly name: string | null | undefined;
        readonly section: string | null | undefined;
      } | null | undefined> | null | undefined;
      readonly email: string | null | undefined;
      readonly externalSync: {
        readonly source: string | null | undefined;
      } | null | undefined;
      readonly firstName: string | null | undefined;
      readonly gradeLevels: ReadonlyArray<{
        readonly id: string;
        readonly name: string | null | undefined;
      } | null | undefined> | null | undefined;
      readonly id: string;
      readonly isActive: boolean;
      readonly lastName: string | null | undefined;
      readonly publicUserId: string | null | undefined;
      readonly roles: ReadonlyArray<{
        readonly name: string | null | undefined;
      } | null | undefined> | null | undefined;
      readonly sites: ReadonlyArray<{
        readonly id: string;
        readonly name: string | null | undefined;
      } | null | undefined> | null | undefined;
      readonly studentTargetGroups: ReadonlyArray<{
        readonly id: string;
        readonly isCurrent: boolean;
        readonly targetGroup: {
          readonly id: string;
          readonly name: string | null | undefined;
        } | null | undefined;
      } | null | undefined> | null | undefined;
      readonly userClasses: ReadonlyArray<{
        readonly class: {
          readonly id: string;
          readonly name: string | null | undefined;
          readonly section: string | null | undefined;
        } | null | undefined;
        readonly isActive: boolean;
      } | null | undefined> | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type ClassByIdQuery = {
  response: ClassByIdQuery$data;
  variables: ClassByIdQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "classId"
  },
  {
    "defaultValue": false,
    "kind": "LocalArgument",
    "name": "skip"
  },
  {
    "defaultValue": false,
    "kind": "LocalArgument",
    "name": "validCurrentRoadmapsOnly"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "classId",
    "variableName": "classId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "section",
  "storageKey": null
},
v5 = [
  (v2/*: any*/),
  (v3/*: any*/)
],
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "SiteNode",
  "kind": "LinkedField",
  "name": "site",
  "plural": false,
  "selections": (v5/*: any*/),
  "storageKey": null
},
v7 = [
  (v3/*: any*/),
  (v2/*: any*/)
],
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "GradeLevelNode",
  "kind": "LinkedField",
  "name": "gradeLevels",
  "plural": true,
  "selections": (v7/*: any*/),
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isActive",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "validCurrentRoadmapsOnly",
      "variableName": "validCurrentRoadmapsOnly"
    }
  ],
  "concreteType": "StudentTargetGroupNode",
  "kind": "LinkedField",
  "name": "studentTargetGroups",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isCurrent",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TargetGroupNode",
      "kind": "LinkedField",
      "name": "targetGroup",
      "plural": false,
      "selections": (v5/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "publicUserId",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "source",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "concreteType": "ExternalSyncNode",
  "kind": "LinkedField",
  "name": "externalSync",
  "plural": false,
  "selections": [
    (v15/*: any*/)
  ],
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "concreteType": "SiteNode",
  "kind": "LinkedField",
  "name": "sites",
  "plural": true,
  "selections": (v5/*: any*/),
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "concreteType": "ClassNode",
  "kind": "LinkedField",
  "name": "class",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v3/*: any*/),
    (v4/*: any*/)
  ],
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "concreteType": "UserNode",
  "kind": "LinkedField",
  "name": "createdBy",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v11/*: any*/),
    (v12/*: any*/)
  ],
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "concreteType": "ExternalSyncNode",
  "kind": "LinkedField",
  "name": "externalSync",
  "plural": false,
  "selections": [
    (v15/*: any*/),
    (v2/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ClassByIdQuery",
    "selections": [
      {
        "condition": "skip",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "ClassNode",
            "kind": "LinkedField",
            "name": "class",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v6/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "UserNode",
                "kind": "LinkedField",
                "name": "users",
                "plural": true,
                "selections": [
                  (v10/*: any*/),
                  (v2/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v9/*: any*/),
                  (v16/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RoleNode",
                    "kind": "LinkedField",
                    "name": "roles",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v17/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ClassNode",
                    "kind": "LinkedField",
                    "name": "classes",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/),
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserClassNode",
                    "kind": "LinkedField",
                    "name": "userClasses",
                    "plural": true,
                    "selections": [
                      (v9/*: any*/),
                      (v18/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v19/*: any*/),
              (v16/*: any*/)
            ],
            "storageKey": null
          }
        ]
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ClassByIdQuery",
    "selections": [
      {
        "condition": "skip",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "ClassNode",
            "kind": "LinkedField",
            "name": "class",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v6/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "UserNode",
                "kind": "LinkedField",
                "name": "users",
                "plural": true,
                "selections": [
                  (v10/*: any*/),
                  (v2/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v9/*: any*/),
                  (v20/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RoleNode",
                    "kind": "LinkedField",
                    "name": "roles",
                    "plural": true,
                    "selections": (v7/*: any*/),
                    "storageKey": null
                  },
                  (v17/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ClassNode",
                    "kind": "LinkedField",
                    "name": "classes",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/),
                      (v4/*: any*/),
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserClassNode",
                    "kind": "LinkedField",
                    "name": "userClasses",
                    "plural": true,
                    "selections": [
                      (v9/*: any*/),
                      (v18/*: any*/),
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v19/*: any*/),
              (v20/*: any*/)
            ],
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "448eb048811c5a2afca03fa2abd7c43d",
    "id": null,
    "metadata": {},
    "name": "ClassByIdQuery",
    "operationKind": "query",
    "text": "query ClassByIdQuery(\n  $classId: ID!\n  $skip: Boolean = false\n  $validCurrentRoadmapsOnly: Boolean = false\n) {\n  class(classId: $classId) @skip(if: $skip) {\n    id\n    name\n    section\n    site {\n      id\n      name\n    }\n    gradeLevels {\n      name\n      id\n    }\n    isActive\n    users {\n      studentTargetGroups(validCurrentRoadmapsOnly: $validCurrentRoadmapsOnly) {\n        id\n        isCurrent\n        targetGroup {\n          id\n          name\n        }\n      }\n      id\n      firstName\n      lastName\n      email\n      publicUserId\n      isActive\n      externalSync {\n        source\n        id\n      }\n      roles {\n        name\n        id\n      }\n      sites {\n        id\n        name\n      }\n      classes {\n        name\n        section\n        id\n      }\n      gradeLevels {\n        name\n        id\n      }\n      userClasses {\n        isActive\n        class {\n          id\n          name\n          section\n        }\n        id\n      }\n    }\n    createdBy {\n      id\n      firstName\n      lastName\n    }\n    externalSync {\n      source\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "d145e34016c526be3154b77be1aba773";

export default node;
